import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './i18n'
import './services/api'
import './assets/main.scss' // Importez votre fichier SCSS global ici
import './assets/rtl.scss'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
// Import mixin global and use it
import global from './mixins/global'

import io from 'socket.io-client'
import { baseURL, baseURLFront } from '../env'

Vue.prototype.$socket = io(baseURL)

Vue.mixin(global)
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.use(ElementUI)

Vue.config.productionTip = false

// Add baseURl globally
Vue.prototype.$baseURI = baseURL.endsWith('/') ? baseURL : baseURL + '/'
Vue.prototype.baseURLFront = baseURLFront || (window.location.origin + '/')

setTimeout(async () => {
  store.commit('login/SET_TOKEN', localStorage.getItem('token'))

  if (window.location.pathname.split('/').length > 0 && window.location.pathname.split('/')[1] !== 'app') await store.dispatch('login/GET_USER')
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
}, 0)
